// core
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

// services
import {TranslateService} from '@ngx-translate/core';
import {UtilsService} from '../utils/utils.service';
import {EmailConfirmationService} from './service/email-confirmation.service';

// models
import {EmailConfirmationKind, EmailConfirmationState} from './model/email-confirmation.model';

/**
 * The page behind the link of a confirmation mail.
 *
 * Opening the page redeems nothing: mail systems open every link of an incoming mail in advance to check it, and
 * would otherwise use up the token before the user clicks. Only the button sends the token. It must never be
 * triggered automatically, because some of these systems execute scripts.
 */
@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
  standalone: false
})
export class EmailConfirmationComponent implements OnInit {

  public kind: EmailConfirmationKind;
  public state: EmailConfirmationState = 'READY';

  private token: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _translateService: TranslateService,
    private _utilsService: UtilsService,
    private _emailConfirmationService: EmailConfirmationService
  ) {
  }

  ngOnInit() {
    this.kind = this._activatedRoute.snapshot.data['kind'];

    this._activatedRoute
      .queryParams
      .subscribe(params => {
        this.token = params['token'];
        // a link without a token cannot be confirmed - no need to offer the button
        this.state = this.token ? 'READY' : 'INVALID';

        // like the confirmation page: the language of the link applies to this page only and is not remembered
        const language = params['language'];
        if (language) {
          this._translateService.setDefaultLang(language);
          this._translateService.use(language);
        }
      });
  }

  public confirm() {
    if (this.state !== 'READY') {
      return;
    }
    this.state = 'LOADING';

    this._emailConfirmationService.confirm(this.kind, this.token).subscribe({
      next: outcome => this.state = outcome,
      error: () => this.state = 'ERROR'
    });
  }

  public goToLogIn() {
    this._utilsService.goToPortal();
  }

}
